import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div>
      <h1 className="text-xl font-semibold">Not found</h1>
      <p className="mt-2 text-sm text-zinc-400">
        That page doesn’t exist.{" "}
        <Link to="/" className="text-zinc-200 underline hover:text-white">
          Back to dashboard
        </Link>
      </p>
    </div>
  );
}
